module.exports = __webpack_public_path__ + "img/eth.ed79179a.svg";